import { render, staticRenderFns } from "./Payfor.vue?vue&type=template&id=24bf7ca4&scoped=true"
import script from "./Payfor.vue?vue&type=script&lang=js"
export * from "./Payfor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf7ca4",
  null
  
)

export default component.exports